/**
 * About and author attribution footer. Minimal text with an interactive
 * color-cycling heart indicator and synchronized author name color.
 */

import { useState, type ReactElement } from 'react';

const HEART_COLORS = [
  '#ef4444', // Red (default)
  '#ec4899', // Pink
  '#a855f7', // Purple
  '#3b82f6', // Blue
  '#06b6d4', // Cyan
  '#10b981', // Emerald
  '#f59e0b', // Amber
  '#f97316', // Orange
] as const;

export function AboutPanel(): ReactElement {
  const [colorIndex, setColorIndex] = useState(0);

  const cycleHeartColor = (): void => {
    setColorIndex((prev) => (prev + 1) % HEART_COLORS.length);
  };

  const currentColor = HEART_COLORS[colorIndex] ?? HEART_COLORS[0];

  return (
    <footer className="settings__footer">
      <p
        className="settings__attribution"
        onClick={cycleHeartColor}
        role="button"
        tabIndex={0}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            cycleHeartColor();
          }
        }}
        title="Click to swap color"
        aria-label="Made with love by Yashwanth Kumar. Click to swap color."
      >
        <span>Made with love</span>{' '}
        <span className="settings__heart" style={{ color: currentColor }} aria-hidden="true">
          ♥
        </span>{' '}
        <span>by</span>{' '}
        <a
          href="https://www.yakuraku.org"
          target="_blank"
          rel="noopener noreferrer"
          className="settings__author-link"
          style={{ color: currentColor }}
          onClick={(event) => {
            event.stopPropagation();
          }}
        >
          Yashwanth Kumar
        </a>
      </p>
    </footer>
  );
}
